
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import DilekceEditor from "@/components/inputs/DilekceEditor.vue";
import DilekceOlusturForm from "@/components/forms/DilekceOlusturForm.vue";
import TakipDilekceOlusturForm from "@/components/forms/TakipDilekceOlusturForm.vue";
import { DilekceEntity } from "@/entity/DilekceEntity";
import { Udf } from "@/classes/HtmlToUdf";
// @ts-ignore
import html2pdf from "../../../node_modules/html2pdf.js/dist/html2pdf";
import JSZip from "jszip";
import * as FileSaver from "file-saver";
import PdfRenderer from "@/components/pdf/PdfRenderer.vue";

@Component({
  components: {
    TakipDilekceOlusturForm,
    DilekceOlusturForm,
    DilekceEditor,
    FormWrapper,
  },
})
export default class DilekceForm extends Mixins(ObjectInputMixin) {
  @Prop() download!: boolean | string;
  @Prop() downloadFromTakip!: boolean | string;
  @Prop() takipId!: number;

  @Ref("dilekceEditor") readonly dilekceEditor!: DilekceEditor;
  @Ref("form") readonly form!: FormWrapper;

  localValue: DilekceEntity = new DilekceEntity();
  manuelDilekceVerileri: Record<string, any> = {};
  secilenDilekceler: Array<DilekceEntity> = [];
  error = false;

  /** Jodit remount anahtarı */
  editorKey = 0;
  loadingSablon = false;

  get isDownload() { return this.download || this.download === ""; }
  get isDownloadFromTakip() { return this.downloadFromTakip || this.downloadFromTakip === ""; }

  /** Düzenle modunda sablonu API'den hydrate et */
  @Watch("localValue.id", { immediate: true })
  async onRecordChanged() {
    await this.hydrateIfEditing();
  }

  @Watch("localValue.sablon")
  onSablonChange() {
    this.error = false;
  }

  private bumpEditorKey() {
    this.$nextTick(() => (this.editorKey += 1));
  }

  async hydrateIfEditing() {
    if (this.loadingSablon) return;
    if (!this.localValue?.id) return;
    if (this.isDownload || this.isDownloadFromTakip) return;

    // Sablon zaten doluysa sadece editor’u tazele
    if (this.localValue.sablon?.trim()) {
      this.bumpEditorKey();
      return;
    }

    this.loadingSablon = true;
    try {
      const { data } = await this.$http.get(`/api/v1/dilekce/${this.localValue.id}`);
      // Var olan alanları koruyarak doldur
      this.localValue = Object.assign(new DilekceEntity(), this.localValue, data);
      this.bumpEditorKey();
    } finally {
      this.loadingSablon = false;
    }
  }

  onClose() {
    this.$emit("onClose");
  }

  /** KAYDET */
  async save(isFarkliKaydet = false, indirmeTuru = "") {
    if (this.isDownload) {
      const tarihAlanlari = ["bugunun_tarihi", "vade_tarihi", "haciz_tarihi", "takip_tarihi"];
      for (const t of tarihAlanlari) {
        this.manuelDilekceVerileri[t] = this.$helper.tarihStr(this.manuelDilekceVerileri[t]);
      }
      this.$http
          .post(`/api/v1/dilekce/${this.localValue.id}/render`, this.manuelDilekceVerileri)
          .then((r) => {
            this.downloadNow([{ isim: this.localValue.isim, data: r.data }], indirmeTuru);
            this.$emit("onSuccess");
          });
      return;
    }

    if (this.isDownloadFromTakip) {
      if (this.form.validateForm()) {
        const files: Array<{ isim: string; data: string }> = [];
        for (const d of this.secilenDilekceler) {
          const r = await this.$http.post(`/api/v1/takip/${this.$route.params.id}/dilekce/${d.id}/render`);
          files.push({ isim: d.isim, data: r.data });
        }
        await this.downloadNow(files, indirmeTuru);
      }
      return;
    }

    // Normal oluştur/düzenle
    this.dilekceEditor?.findAlanlar();

    if (this.localValue.id) {
      if (isFarkliKaydet) {
        if (this.localValue.isim === this.dilekceEditor.eskiDilekceIsim) {
          this.localValue.isim = `${this.localValue.isim} (${new Date().toISOString()})`;
        }
        const payload: any = { ...this.localValue, standart_mi: false };
        delete payload.id;
        this.$http.post("/api/v1/dilekce/", payload).then(() => this.$emit("onSuccess"));
      } else {
        if (!this.localValue.sablon?.trim()) { this.error = true; return; }
        this.$http.put(`/api/v1/dilekce/${this.localValue.id}`, this.localValue).then(() => this.$emit("onSuccess"));
      }
    } else {
      if (!this.localValue.sablon?.trim()) { this.error = true; return; }
      this.$http.post("/api/v1/dilekce", this.localValue).then(() => {
        // yeni kayıttan sonra tamamen sıfırla
        this.localValue = new DilekceEntity();
        this.bumpEditorKey();
        this.$emit("onSuccess");
      });
    }
  }

  /** İNDİR */
  async downloadNow(response: Array<{ isim: string; data: string }>, indirmeTuru: string) {
    const zip = new JSZip();

    if (indirmeTuru === "udf") {
      response.forEach((d) => {
        const udf = new Udf("", []);
        const clean = udf.htmlCleaner(d.data);
        const xmlTag = udf.XMLTemplateTagCreated(clean);
        const xml = udf.prepareToDownload(xmlTag, "deneme", true);
        if (xml !== undefined) zip.file(`${d.isim}.udf`, new Blob([xml], { type: "application/xml" }));
      });
    } else if (indirmeTuru === "word") {
      const header = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office"
              xmlns:w="urn:schemas-microsoft-com:office:word"
              xmlns="http://www.w3.org/TR/REC-html40">
          <head><meta charset="utf-8"></head><body>`;
      const footer = "</body></html>";
      response.forEach((d) => {
        zip.file(`${d.isim}.doc`, new Blob([header + d.data + footer], { type: "application/vnd.ms-word;charset=utf-8" }));
      });
    } else if (indirmeTuru === "pdf") {
      for (const d of response) {
        // 1) PdfRenderer ile gelen HTML
        const comp: any = new (PdfRenderer as any)({ propsData: { content: d.data } });
        comp.$mount();
        let rawHtml: string = comp.getCleanHtml() || "";
        rawHtml = rawHtml.replace(/&nbsp;/g, " "); // kırılmaz boşlukları düzelt

        // 2) PDF için stil sarımı
        const printable = `
          <!doctype html>
          <html lang="tr">
            <head>
              <meta charset="utf-8" />
              <style>
                .pdf-wrap{
                  line-height:1.5;
                  font-family:'Times New Roman', serif;
                  font-size:12pt;
                  white-space:pre-wrap;
                  word-break:break-word;
                  overflow-wrap:anywhere;
                  hyphens:auto;
                }
                .pdf-wrap p{ margin:0; }
                .page-break-before{ page-break-before: always; }
                .page-break-after { page-break-after:  always; }
                .page-break-avoid { page-break-inside: avoid; }
              </style>
            </head>
            <body><div class="pdf-wrap">${rawHtml}</div></body>
          </html>`;

        // 3) PDF oluştur
        await html2pdf()
            .from(printable)
            .set({
              margin: [15, 15, 20, 15],
              filename: `${d.isim}.pdf`,
              image: { type: "jpeg", quality: 1.0 },
              html2canvas: {
                scale: 2.5,
                useCORS: true,
                letterRendering: true,
                allowTaint: true,
                logging: false,
                imageTimeout: 0,
                removeContainer: true,
              },
              jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait",
                compress: true,
                precision: 16,
              },
              pagebreak: {
                mode: ["avoid-all", "css", "legacy"],
                before: ".page-break-before",
                after: ".page-break-after",
                avoid: ".page-break-avoid",
              },
            })
            .toPdf()
            .get("pdf")
            .then((pdf: any) => {
              const total = pdf.internal.getNumberOfPages();
              const w = pdf.internal.pageSize.getWidth();
              const h = pdf.internal.pageSize.getHeight();
              for (let p = 1; p <= total; p++) {
                pdf.setPage(p);
                pdf.setFontSize(9);
                pdf.setTextColor(100, 100, 100);
                pdf.text(`Sayfa ${p} / ${total}`, w - 25, h - 10);
              }
            })
            .outputPdf("blob")
            .then((file: Blob) => {
              zip.file(`${d.isim}.pdf`, file);
              comp.$destroy();
            });
      }
    }

    zip.generateAsync({ type: "blob" }).then((blob) => FileSaver.saveAs(blob, "Dilekçeler"));
  }
}
